import {sendPostRequest} from "./apiv4helper";

const BatchJobTypeEnum = {
    STATION_CHANGE_CONFIGURATION: "StationChangeConfigurationBatchJob",
    STATION_UPDATE_FIRMWARE: "StationFirmwareUpdateBatchJob",
    STATION_SETTINGS: "StationSettingsBatchJob"
};

function startBatchJob(jobType, sellerId, parameters) {
    const path = `/admin/batch/jobs`;
    let data = {
        "sellerId": sellerId,
        "jobType": jobType,
        "jobParameters": {...parameters}
    };

    return sendPostRequest(
        path,
        data
    );
}

export {
    BatchJobTypeEnum,
    startBatchJob
}